import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=e79bf1cc&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"
import style0 from "./agreement.vue?vue&type=style&index=0&id=e79bf1cc&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79bf1cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e79bf1cc')) {
      api.createRecord('e79bf1cc', component.options)
    } else {
      api.reload('e79bf1cc', component.options)
    }
    module.hot.accept("./agreement.vue?vue&type=template&id=e79bf1cc&scoped=true", function () {
      api.rerender('e79bf1cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/agreement.vue"
export default component.exports